export enum DisabilityEnum {
	ALL = 'T',
	HAS_ACCESSIBILITY = 'S',
}
